import { Component } from '@angular/core';
import { Router } from '@angular/router';

import {  NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService} from '../';
import { NotificationsService } from 'angular2-notifications';
import { ModalPopupService } from './modal-popup/modal-popup.service';
import * as $ from 'jquery';


@Component({
  selector: 'sessionWarning-modal',
  template: `<h1 class="section-header">Session Timeout Warning</h1>
              <div class="modal-body">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <span>Your session is about to expire. You will be logged out in 1 minute.</span>
                    </div>
                  </div>
                </div>
              </div>
             <div class="modal-footer justify-content-center">
               <button class="btn btn-primary" (click)="continue()">Ok</button>
             </div>
            `
})

export class SessionWarningModal {
  modelRef: NgbModalRef;

  constructor(
      private router: Router,
      private authService: AuthService,
      private notificationService: NotificationsService,
      private activeModal: NgbActiveModal,
      private modalService: ModalPopupService
  ){}

  //Process session timeout
  continue(){
    //this.authService.signOut();
    //Hide Toast Notification
    this.notificationService.remove();
    //Redirect to Login page
    //this.router.navigate(['login']);
    //Close modal
    this.activeModal.close('Close click');
    //Make sure all ng-bootstrap modals are killed since API has limited support for closing all active modals
    $("ngb-modal-window:visible").remove();
    $("ngb-modal-backdrop:visible").remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/sessionWarning.component.ts